!(function () {
  function t(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(t);
          e &&
              (n = n.filter(function (e) {
                  return Object.getOwnPropertyDescriptor(t, e).enumerable;
              })),
              r.push.apply(r, n);
      }
      return r;
  }
  function e(e) {
      for (var n = 1; n < arguments.length; n++) {
          var o = null != arguments[n] ? arguments[n] : {};
          n % 2
              ? t(Object(o), !0).forEach(function (t) {
                    r(e, t, o[t]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o))
              : t(Object(o)).forEach(function (t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
                });
      }
      return e;
  }
  function r(t, e, r) {
      return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = r), t;
  }
  window.addEventListener(
      "message",
      function (t) {
          var r;
          if (null == t || null === (r = t.data) || void 0 === r ? void 0 : r.type)
              try {
                  var n = t.data;
                  switch (n.type) {
                      case "ADD_TO_CART":
                          return void (function (t) {
                              var r,
                                  n = t.sofaBundleId,
                                  o = t.compositionName,
                                  i = t.items.map(function (t) {
                                      return { quantity: t.quantity, id: t.shopifyId, properties: e({ sofaBundleId: n, Composition: o }, t.photo ? { photo: t.photo } : {}) };
                                  });
                              null ===
                                  (r = i.find(function (t) {
                                      return t.properties.photo;
                                  })) ||
                                  void 0 === r ||
                                  r.properties.photo;
                              console.info("Add to cart", i),
                                  fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: i }) })
                                      .then(function (t) {
                                          return t.json();
                                      })
                                      .then(function (t) {
                                        window.location.assign('/cart')
                                      })
                                      .catch(console.error);
                          })(n.payload);
                      default:
                          return;
                  }
              } catch (t) {
                  console.error(t);
              }
      },
      !1
  );
})();
